import { themes } from '../MatxTheme/initThemes';
import layout1Settings from './Layout1/Layout1Settings';

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const MatxLayoutSettings = {
  activeLayout: 'layout1', 
  activeTheme: 'blue', 
  perfectScrollbar: false,

  themes: themes,
  layout1Settings, 

  secondarySidebar: {
    show: true,
    open: false,
    theme: 'slateDark1' 
  },
  // Footer options
  footer: {
    show: true,
    fixed: false,
    theme: 'slateDark1' 
  }
};
